import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPostPage = () => {
  const { slug } = useParams();
  const { t, lang } = useLanguage();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${API}/blog/${slug}`)
      .then((res) => setPost(res.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <main className="bg-white pt-36 pb-20 text-center">
        <div className="container-page">
          <h1 className="font-display font-black text-4xl text-navy">Article introuvable</h1>
          <Link to="/blog" className="mt-6 inline-block link-underline">Retour aux articles</Link>
        </div>
      </main>
    );
  }

  if (!post) {
    return (
      <main className="bg-white pt-36 pb-20 text-center">
        <div className="container-page">
          <p className="text-muted-foreground">Chargement…</p>
        </div>
      </main>
    );
  }

  return (
    <main data-testid="blog-post-page" className="bg-white pt-28 md:pt-36 pb-20">
      <article className="container-page max-w-4xl">
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-[#FF5A1F]"
        >
          <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
          {t.common.back}
        </Link>

        <div className="mt-6">
          <span className="chip">{lang === "fr" ? post.category_fr : post.category_en}</span>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]">
            {lang === "fr" ? post.title_fr : post.title_en}
          </h1>
          <p className="mt-4 text-sm text-muted-foreground">
            {new Date(post.date).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}{" "}
            · {post.read_time} {t.blog.minRead}
          </p>
        </div>

        <div className="mt-10 aspect-[16/9] rounded-2xl overflow-hidden">
          <img
            src={post.image}
            alt={lang === "fr" ? post.title_fr : post.title_en}
            className="h-full w-full object-cover"
            loading="eager"
          />
        </div>

        <div className="prose prose-lg max-w-none mt-10">
          <p className="text-lg leading-relaxed text-foreground/85">
            {lang === "fr" ? post.excerpt_fr : post.excerpt_en}
          </p>
          <div className="mt-6 text-base leading-relaxed text-foreground/80 whitespace-pre-line">
            {lang === "fr" ? post.content_fr : post.content_en}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex items-center justify-between">
          <Link to="/blog" className="link-underline">
            <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true"></i>
            {t.common.back}
          </Link>
          <Link to="/#contact" className="btn-primary !py-2.5 !px-5 text-xs">
            <i className="fa-solid fa-calendar-check" aria-hidden="true"></i>
            {t.nav.bookRdv}
          </Link>
        </div>
      </article>
    </main>
  );
};

export default BlogPostPage;
